export enum PlatformActionTypes {
  GetPlatformLocal = 'GetPlatformLocal',
  SetPlatform = 'SetPlatform',
}
